import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';
import { SystemTypeIdEnum } from 'src/app/domain/registration/enums/system-type.enum';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { IPartner } from 'src/app/domain/registration/models/IPartner';
import { ISystem } from 'src/app/domain/registration/models/ISystem';
import { ITraining } from 'src/app/domain/registration/models/ITraining';
import { PermissionService } from 'src/app/shared/permission.service';
import { PartnerService } from '../../partners/crud-service';
import { SystemService } from '../../systems/crud-service';
import { CES_CONFIG_FIELDS } from '../crud-config';
import { AbstractCrudCES } from 'src/app/shared/components/crud/abstract-crud-ces';

@Component({
  selector: 'app-training-ces',
  templateUrl: './crud-ces.component.html',
  styleUrls: ['./crud-ces.component.sass'],
  providers: [SystemService, PartnerService],
})
export class TrainingCESComponent extends AbstractCrudCES<ITraining> implements OnInit, OnDestroy {
  systemSelected: ISystem | null = null;
  override config: IFieldConfig[] = CES_CONFIG_FIELDS;
  override data: ITraining;

  typeSub: Subscription | undefined;
  partnerSub: Subscription | undefined;
  element: any;
  partnersSelected: any = [];

  setFields() {
    this.form.patchValue(this.data);

    if (this.data && this.data.system && typeof this.data.system === 'object') {
      this.systemSelected = this.data.system;
      this.form.get('system')?.setValue(this.data.system);
    } else {
      console.warn('❌ Nenhum sistema encontrado nos dados para carregar');
    }

    this.typeSub = this.form
      .get('type')
      ?.valueChanges.subscribe((value: any) => {
        this.form.get('system')?.setValue('');
        this.getFieldConfig('system').componentData = {
          params: { type: SystemTypeIdEnum[value] },
        };
      });
  }

  constructor(
    public dialogRef: MatDialogRef<TrainingCESComponent>,
    @Inject(MAT_DIALOG_DATA)
    data: { type: TypeCesEnum; element: ITraining },
    private cdr: ChangeDetectorRef,
    private systemService: SystemService,
    private partnerService: PartnerService,
    public override fb: FormBuilder,
    public permissionService: PermissionService,
  ) {
    super(fb);
    this.typeCes = data.type;
    this.data = data.element;
    this.title = this.typeCes;
  }

  override ngOnInit(): void {
    this.form = this.createGroup();
    this.setFields();
  }

  ngOnDestroy(): void {
    this.typeSub?.unsubscribe();
  }

  ngAfterViewInit() {
    this.setFields();
    this.cdr.detectChanges();
  }

  onSubmit(value: any) {
    const system = this.systemSelected;
    if (system) {
      value['system'] = system.name;
      value['systemId'] = system.id;
    } else {

      if (value['system'] && typeof value['system'] === 'object' && value['system'].id) {
        value['system'] = value['system'].name;
        value['systemId'] = value['system'].id;
      }
    }

    value['type'] = SystemTypeIdEnum[value['type']];
    value['partners'] = this.partnersSelected?.map((partner: IPartner) => partner.id) ?? [];
    this.dialogRef.close({ element: value });
  }

  onCancel() {
    this.dialogRef.close();
  }

  changeType(type: TypeCesEnum) {
    this.typeCes = type;
    this.dialogRef.close({ changeType: type });
  }

  delete() {
    this.dialogRef.close({ delete: true });
  }

  selectSystem(event: any) {
    this.systemSelected = event;

    if (event && event.id) {
    } else {
      this.systemSelected = null;
    }
  }

  selectPartners(event: any) {
    if (event && event.length > 0) {
      this.partnersSelected = event.map((partner: any) => ({
        id: partner.id,
        name: partner.name,
      }));
    } else {
      this.partnersSelected = [];
    }
  }
}